import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import _ from 'lodash';


import { getManagerTeam } from '../../actions/consultant';
import ConsultantItem from './ConsultantItemSmall';



 
class ManagerView extends React.Component {

  fourth = React.createRef();

  constructor(props) {
    
    super(props);

    this.state = {
      consultant: null,
    }

    this.props.getManagerTeam(this.props.match.params.id);
    
  }


  componentDidMount() {
    window.scrollTo(0, 0);


  }

  componentDidUpdate(prevProps) {

  }




  renderConsultants(consultants,translate) {


    var dom = []
    _.each(consultants, function(consultant, i){


      dom.push(
        <div key={i}>
            <div key={'consultant'+i}>
              <h1>
                <ConsultantItem
                  key={Date.now()+"-"+consultant._id}
                  id={consultant._id}
                  progression={consultant.progression.globalPercentage}
                  name={{firstName : consultant.user.sageContent.profile.firstName, lastName : consultant.user.sageContent.profile.lastName}}
                  validationInformation={consultant.validationInformation}
                  small={false}
                  circle={true}
                  translate = {translate}
                />
              </h1>
            </div>
            

        </div>
      )
    })

    return (
      dom
    )
  }

  render() {


    return (
      <>    
      <div className="dashboard">     
        {!this.props.consultants ?
          <h3 style={{ textAlign: 'center', marginTop: '50px'}}>Loading...</h3> :
          <div>
            <div className="dashboard-header">
            </div>            
              <div className="page-container">
                <h1>My consultants</h1>
                {this.renderConsultants(this.props.consultants,this.props.translate)}
              </div>
          </div>
        }
      </div>
      </>

    )
  }
}

const mapStateToProps = state => ({
  consultants: state.consultant.consultants,
  message: state.consultant.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getManagerTeam
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(withLocalize(ManagerView)));
